import { Component, inject, OnInit, signal } from '@angular/core';
import { BlogsService } from '../../../shared/services/blogs.service';
import { AdminButtonComponent, AdminCardComponent, AdminPageHeaderComponent } from '../../../shared/admin';
import { ApiService } from '../../../core/services/api.service';

@Component({
  selector: 'app-platform-blog-subscribers-page',
  standalone: true,
  imports: [AdminPageHeaderComponent, AdminCardComponent, AdminButtonComponent],
  template: `
    <section>
      <app-admin-page-header title="Newsletter subscribers">
        <ng-container actions>
          <app-admin-button variant="ghost" type="button" (click)="exportCsv()">Export CSV</app-admin-button>
        </ng-container>
      </app-admin-page-header>
      @for (item of items(); track item.email) {
        <app-admin-card>
          <div class="font-medium">{{ item.email }}</div>
          <p class="cg-form-help">
            {{ item.fullName || '—' }} · {{ item.status }} · {{ item.source }}
            @if (item.sourcePage) { · {{ item.sourcePage }} }
          </p>
        </app-admin-card>
      }
    </section>
  `,
})
export class PlatformBlogSubscribersPageComponent implements OnInit {
  private readonly blogs = inject(BlogsService);
  private readonly api = inject(ApiService);
  readonly items = signal<Array<{ email: string; fullName?: string; status: string; source: string; sourcePage?: string }>>([]);

  ngOnInit(): void {
    this.blogs.listSubscribers().subscribe((data) => this.items.set(data.items));
  }

  exportCsv(): void {
    window.open(`${this.api.baseUrl}/platform/blog-subscribers/export/csv`, '_blank');
  }
}
